module.exports = __webpack_public_path__ + "static/media/menu-grid-r.9fabdc91.svg";